export const NEW_PRODUCT_LABEL = 'New product';
export const PRODUCT_DETAILS_HEADING = 'Product details';

export const getOptionsHeadingText = (
  purchasable: boolean,
  hasOptions: boolean,
  personalisable: boolean,
): string | null => {
  if (!purchasable || !hasOptions) {
    return null;
  }

  return personalisable ? 'Personalisation options' : 'Product options';
};
